import { vec2 } from "gl-matrix"
import { Rect } from "@/lib/ai/detection/face-detection"
import { rectClamp, rectPadding } from "@/utils/math"

export interface PaddedFaceRect extends Rect {
	internalAnchor: vec2
	maxZoom: number
}

/**
 * Generates larger rects around a face crop previews to allow for adjusting the display
 *
 * @param rect
 * @returns rect with padding
 */
export const padFaceRect = (rect: Rect): PaddedFaceRect => {
	const paddedRect = rectClamp(
		rectPadding(rect, Math.min(rect.width, 0.25), Math.min(rect.height, 0.25)),
		0.0,
		1.0,
	)

	const originX = (rect.x + rect.width / 2 - paddedRect.x) / paddedRect.width
	const originY = (rect.y + rect.height / 2 - paddedRect.y) / paddedRect.height
	const internalAnchor = [originX, originY] as vec2

	const maxZoom = Math.min(
		paddedRect.width / (1.2 * rect.width),
		paddedRect.height / (1.2 * rect.height),
	)

	return { ...paddedRect, internalAnchor, maxZoom }
}
